import { Box, Grid } from '@breathelife/mui';
import { RenderingSubsection } from '@zinnia/form-engine-sdk';
import { Fragment, ReactElement, useMemo, useState } from 'react';
import { useParticipantsContext } from '../../../../../../Context/ParticipantsContextProvider';
import styled from '../../../../../../Styles/themed-styled-components';
import { AssistedApplicationOverlay } from '../../../../AssistedApplicationOverlay';
import { SubsectionHeader } from '../../SubsectionHeader';
import { AuraNextFormContainer } from './AuraNextFormContainer';
import { AuraNextParticipant } from './AuraNextParticipant';

export const ParticipantContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.theme.colors.grey[10]};
  border: 1px solid ${(props) => props.theme.colors.grey[30]};
  border-radius: 4px;
  padding: 8px 8px 8px 24px;
  margin-bottom: 16px;
`;

type AuraNextMedicalQuestionnaireSubsectionProps = {
  subsection: RenderingSubsection;
};
export function AuraNextMedicalQuestionnaireSubsection(
  props: AuraNextMedicalQuestionnaireSubsectionProps,
): ReactElement {
  const [formParticipantId, setFormParticipantId] = useState<string | null>(null);

  const { participants } = useParticipantsContext();

  const [selectedParticipant, selectedParticipantName] = useMemo(() => {
    const selectedP = participants.find((p) => p.id === formParticipantId) || null;
    const name = selectedP?.data?.firstName + ' ' + selectedP?.data?.lastName;
    return [selectedP, name];
  }, [formParticipantId, participants]);

  return (
    <Fragment>
      <SubsectionHeader title={props.subsection.title} text={props.subsection.text} />
      <Box mb={4}>
        <Grid container spacing={1} direction={'column'}>
          {participants.map((participant) => (
            <Grid item key={participant.id}>
              <AuraNextParticipant participant={participant} onFormParticipantIdChange={setFormParticipantId} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <AssistedApplicationOverlay isOpen={!!formParticipantId}>
        {selectedParticipant && formParticipantId && (
          <AuraNextFormContainer
            participant={{
              id: selectedParticipant.id,
              name: selectedParticipantName,
              applicationId: selectedParticipant.applicationId,
            }}
          />
        )}
      </AssistedApplicationOverlay>
    </Fragment>
  );
}
